import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import SignInButtons from '@/shared/domains/oauth/components/signin-buttons'
import { cn } from '@/shared/utils'
import { useLocales } from '@/shared/hooks/useLocales'

export interface PaywallContentProps {
  /** 추가 CSS 클래스 */
  className?: string
}

const PaywallContent: FC<PaywallContentProps> = ({ className }) => {
  const { isLocale } = useLocales()
  const { t } = useTranslation()

  if (!isLocale.KR) {
    return null
  }

  return (
    <div className={cn(' bg-white', className)}>
      <SignInButtons />

      {/* 무료 서비스 안내 */}
      <div className={cn('text-center py-4')}>
        <p className={cn('text-xs text-gray-500 leading-relaxed')}>
          {t('paywall.freeService', '강남언니는 무료로 이용할 수 있는 서비스입니다.')}
        </p>
      </div>
    </div>
  )
}

export default PaywallContent
